import { useEffect, useState } from "react";

const TextFileReader = ({ files }) => {
  const [fileContents, setFileContents] = useState([]);

  const readFiles = (files) => {
    if (files?.length > 0) {
      const readers = files.map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) =>
            resolve({ name: file.name, content: e.target.result });
          reader.readAsText(file);
        });
      });

      Promise.all(readers).then((results) => setFileContents(results));
    }
  };

  useEffect(() => {
    readFiles(files);
  }, [files]);

  return (
    <div className="text-file-reader">
      <div className="header-box"></div>

      <div className="file-container">
        <div className="file-content-box">
          <div className="file-content-inner">
            {fileContents?.length > 0 && (
              <div className="file-list">
                {fileContents.map(({ name, content }, index) => (
                  <div key={index} className="file-item">
                    <h3 className="file-title">{name}</h3>
                    <pre className="file-text">{content}</pre>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextFileReader;
